import CustomBreadCrumb from '../../../constants/CustomBreadCrumb'
import {ReportCard} from '../../../components/ReportCard'
import CustomCard from '../../../constants/CustomCard'

const SupplyChainReportsPage = () => {
  const items = [
    {
      title: 'STOCK ITEMS',
      to: '/stock-items-report',
      linkName: 'STOCK ITEMS'
    },{
      title: 'STOCK BALANCE',
      to: '/stock-balance-report',
      linkName: 'STOCK BALANCE'
    },{
      title: 'LOCATION SUMMARY',
      to: '/location-summary-report',
      linkName: 'LOCATION SUMMARY'
    }
  ]
  return (
    <>
      <CustomBreadCrumb title={'Supply Chain Reports'}  isReport={false} isDashboard={false}/>
      <div className="row mt-5 g-8">
        {
          items.map((item, index) => (
              <div key={index} className='col-xl-3'>
                <CustomCard url={item?.to} title={item?.title} />
              </div>
            )
          )
        }
      </div>
    </>
  );
}

export default SupplyChainReportsPage;